<template>
  <font-awesome-icon
    icon="th-large"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faThLarge } from '@fortawesome/free-solid-svg-icons'

library.add(faThLarge)

export default {
  name: 'CoozzyThLargeIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
